import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/images/Turkystan.png'
import _imports_1 from '@/assets/images/turk1.jpg'
import _imports_2 from '@/assets/images/turk2.jpg'
import _imports_3 from '@/assets/images/turk3.jpg'
import _imports_4 from '@/assets/images/turk4.jpg'
import _imports_5 from '@/assets/images/turk5.jpg'


const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "container-fluid intro" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-7" }, [
      /*#__PURE__*/_createVNode("div", { class: "left-region-image" }, [
        /*#__PURE__*/_createVNode("img", { src: _imports_0 })
      ])
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col-12 col-sm-5" }, [
      /*#__PURE__*/_createVNode("h2", { class: "right-region-paragraf" }, "Туркестанская область"),
      /*#__PURE__*/_createVNode("div", { class: "left-region-text" }, " Туркестанская область – центр историко-познавательного туризма Казахстана. В регионе расположено множество древних достопримечательностей. Не менее популярны поездки в эти места с оздоровительными целями, а также для проведения активного отдыха на природе. ")
    ])
  ])
], -1)
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Богатый Туристский Потенциал")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, " Этот регион – культурный и духовный центр столица тюркского мира с историей, уходящей вглубь веков. Как развивается туризм в Туркестанской области? Здесь созданы все необходимые условия для профильной деятельности. Это не только открытие новых и обустройство существующих мест размещения и объектов придорожного сервиса, но также культурно-исторических центров, музеев, театров, аквапарков, торгово-развлекательных центров, восточных базаров, кафе и ресторанов. ")
      ])
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-table" }, [
        /*#__PURE__*/_createVNode("table", { id: "city-table" }, [
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Единовременная вместимость (койко-мест) мест размещения, шт "),
            /*#__PURE__*/_createVNode("td", null, "7670")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, "Заполняемость гостиниц (койко-мест), %"),
            /*#__PURE__*/_createVNode("td", null, "20,0")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по внутреннему туризму (резиденты), чел "),
            /*#__PURE__*/_createVNode("td", null, "133444")
          ]),
          /*#__PURE__*/_createVNode("tr", null, [
            /*#__PURE__*/_createVNode("th", null, " Обслужено посетителей местами размещения по въездному туризму (нерезиденты). чел "),
            /*#__PURE__*/_createVNode("td", null, "6587")
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Исторические Туры")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" Чаще всего, как показываетстатистика туризма Туркестанской области, иностранные и местные туристы заказывают туры в заповедник-музей "),
          /*#__PURE__*/_createVNode("b", null, "«Азрет-Султан»"),
          /*#__PURE__*/_createTextVNode(" в городе Туркестан, где главной, но не единственной достопримечательностью является "),
          /*#__PURE__*/_createVNode("b", null, "мавзолейный комплекс Ходжи Ахмеда Ясави"),
          /*#__PURE__*/_createTextVNode(". Здесь же можно посетить "),
          /*#__PURE__*/_createVNode("b", null, "подземную мечеть Хильвет, музей Жума мечеть, музей-мавзолей Рабиги Султан Бегим"),
          /*#__PURE__*/_createTextVNode(" и другие объекты. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Маршруты Выходного Дня")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" В окрестностях Туркестана очень много природных, исторических и культурных достопримечательностей, потому высоко востребованы однодневные экскурсии. В познавательных целях можно посетить городище "),
          /*#__PURE__*/_createVNode("b", null, "Сауран, Отрарский оазис, пещеру Акмешит"),
          /*#__PURE__*/_createTextVNode(". Как показывает статистикаиной формат поездок – круизного типа, с ночевками в отелях по пути следования – также очень популярен, как среди казахстанцев, так и среди иностранных туристов. ")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row-2" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-paragraf" }, "Другие Поездки")
    ]),
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("div", { class: "region-way-text" }, [
        /*#__PURE__*/_createVNode("p", null, [
          /*#__PURE__*/_createTextVNode(" С оздоровительными целями можно отправиться на местные минеральные воды – например, в курортную зону "),
          /*#__PURE__*/_createVNode("b", null, "«Сарыагаш»"),
          /*#__PURE__*/_createTextVNode(", где действует множество санаториев и баз отдыха. Целебен климат и в других районах области. «Зеленый» туризм развит в "),
          /*#__PURE__*/_createVNode("b", null, "Аксу-Жабаглинском заповеднике, Сайрам-Угамском национальном парке, заповеднике «Каратау»"),
          /*#__PURE__*/_createTextVNode(", в долинах многочисленных рек; горный – около Угамского хребта, хребта "),
          /*#__PURE__*/_createVNode("b", null, "Боралдая"),
          /*#__PURE__*/_createTextVNode(" или "),
          /*#__PURE__*/_createVNode("b", null, "Каржантауских гор"),
          /*#__PURE__*/_createTextVNode(". ")
        ]),
        /*#__PURE__*/_createVNode("p", null, " Перспективное направление – организация агротуров. Статистика туризма Казахстана показывает, что в последние годы стали очень популярны экскурсии в местные хозяйства пастбищного овцеводства, в виноградники и фруктовые сады, и Туркестанской области есть что тоже предложить в этом плане. Также можно рассмотреть возможность организации экскурсий в места добычи поделочных камней, с посещением мастер-классов по изготовлению украшений у местных ремесленников. ")
      ])
    ])
  ])
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "container" }, [
  /*#__PURE__*/_createVNode("div", { class: "row" }, [
    /*#__PURE__*/_createVNode("div", { class: "col" }, [
      /*#__PURE__*/_createVNode("h2", { class: "section__title" }, "ФОТОГАЛЕРЕЯ")
    ])
  ])
], -1)
const _hoisted_8 = { class: "container" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "regio-swiper" }
const _hoisted_12 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_1
}, null, -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_2
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_3
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_4
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("img", {
  class: "region-photo",
  src: _imports_5
}, null, -1)

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_adaptive_main_top_line = _resolveComponent("adaptive-main-top-line")
  const _component_swiper_slide = _resolveComponent("swiper-slide")
  const _component_swiper = _resolveComponent("swiper")
  const _component_Downloaded = _resolveComponent("Downloaded")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_adaptive_main_top_line),
    _hoisted_1,
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _createVNode("div", _hoisted_8, [
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_swiper, {
              "slides-per-view": 1,
              "space-between": 40,
              loop: false,
              navigation: "",
              onSwiper: _ctx.onSwiper,
              onSlideChange: _ctx.onSlideChange
            }, {
              default: _withCtx(() => [
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_12
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_15
                  ]),
                  _: 1
                }),
                _createVNode(_component_swiper_slide, null, {
                  default: _withCtx(() => [
                    _hoisted_16
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSwiper", "onSlideChange"])
          ])
        ])
      ])
    ]),
    (!_ctx.downloaded)
      ? (_openBlock(), _createBlock(_component_Downloaded, { key: 0 }))
      : _createCommentVNode("", true)
  ], 64 /* STABLE_FRAGMENT */))
}